import { z } from "zod";

export const sport = z.enum([
  "CSGO",
  "LOL",
  "STARCRAFT",
  "STARCRAFT_1",
  "DOTA2",
  "ROCKET_LEAGUE",
  "OVERWATCH",
  "PUBG",
  "CALL_OF_DUTY",
  "UNKNOWN",
  "HEARTHSTONE",
  "NBA2K",
  "RAINBOW_SIX",
  "SMITE",
  "KING_OF_GLORY",
  "FIFA",
  "EMOTORSPORT",
  "ARENA_OF_VALOR",
  "VALORANT",
  "KRUNKER",
  "WARCRAFT",
  "FORTNITE",
  "E_ICE_HOCKEY",
  "BATTLEFIELD_V",
  "WARCRAFT_3",
  "HALO_INFINITE",
  "CALL_OF_DUTY_MOBILE",
  "LOL_WILD_RIFT",
  "APEX_LEGENDS",
  "AGE_OF_EMPIRES",
  "MOBILE_LEGENDS",
  "AMERICAN_FOOTBALL",
  "BASKETBALL",
  "SOCCER",
  "BOXING",
  "MMA",
  "CRICKET",
  "GOLF",
  "ICE_HOCKEY",
  "MOTORSPORT",
  "TENNIS",
  "FORMULA_ONE",
  "RUGBY",
  "AUSSIE_RULES",
  "RUGBY_LEAGUE",
  "TABLE_TENNIS",
  "BASEBALL",
  "OLYMPICS",
  "ATHLETICS",
  "ARCHERY",
  "BADMINTON",
  "BEACH_VOLLEY",
  "DIVING",
  "EQUESTRIAN",
  "FIELD_HOCKEY",
  "GYMNASTICS",
  "HANDBALL",
  "ROWING",
  "SAILING",
  "SKATEBOARDING",
  "SOFTBALL",
  "SURFING",
  "SWIMMING",
  "TRIATHLON",
  "VOLLEYBALL",
  "WATERPOLO",
  "WEIGHTLIFTING",
  "WRESTLING",
  "BASKETBALL_3X3",
  "ALPINE_SKIING",
  "FIGURE_SKATING",
  "FREESTYLE_SKIING",
  "SKELETON",
  "BIATHLON",
  "BOBSLEIGH",
  "NORDIC_COMBINED",
  "SKI_JUMPING",
  "SNOWBOARD",
  "SPEED_SKATING",
  "LUGE",
  "CURLING",
  "POLITICS",
  "HORSE_RACING",
  "GREYHOUNDS",
  "HARNESS_RACING",
  "NOVELTIES",
  "DARTS",
  "SNOOKER",
]);

export type Sport = z.infer<typeof sport>;
